/**
 * A roster slot in words — "Advisor 3", "Principal 2", "Lead advisor" — the one spelling of a slot
 * on every screen that names one: the hub's Advisors & principals and a person's Teams & firms,
 * and the work-item pane and queue, which name the team member an item is about by the slot of
 * the roster row listing its CRD (SR-396 W3). Here rather than in the roster's page module so the
 * compliance pages need not import the hub's section to say it.
 */

/** A role's words for a slot, or the role as spelled, with its number. */
const ROLE_WORDS: Readonly<Record<string, string>> = {
  member: 'Advisor',
  principal: 'Principal'
};

export function slotWords({ role, slot }: { role: string; slot: number }): string {
  if (role === 'lead') return 'Lead advisor';
  return `${ROLE_WORDS[role] ?? role} ${slot}`;
}
